
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/services",
      function () {
        return require("private-next-pages/brands/services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/services"])
      });
    }
  